// extracted by mini-css-extract-plugin
module.exports = {"location-container--header":"fZarM","body":"GdkWc","body-art":"+Thfz","rc-tabs-bar":"OYCKi","rc-tabs-tab":"_7m8pB","rc-tabs-tab-active":"R8Q-W"};